import { useSelector } from 'react-redux';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CButton, CCard, CCardBody, CCardHeader } from '@coreui/react';

import { RuleContext } from '../CreateFormCrawlRule';
import FormCrawlRuleTable from '../FormCrawlRuleTable';

const Step3 = ({ actionType }) => {
     const { rule, activeStep, setActiveStep } = useContext(RuleContext);

     const selectedListenerRule = useSelector((state) => state.subscriber.selectedListenerRule);

     const isShowConditionField = !!selectedListenerRule && !!rule.name?.trim() && rule.conditions.length > 0;

     return (
          <CCard className={`cvr-step-3 ${activeStep === 3 ? 'cvr-step-card' : 'difference-step'}`}>
               <CCardHeader>
                    {activeStep === 3 ? (
                         <h5>Step 3: Select Condition Fields</h5>
                    ) : (
                         <div className="rule-step d-inline-flex justify-content-between align-items-center w-100">
                              <h5 className="mb-0 inactive">Step 3: Condition Fields</h5>
                              {isShowConditionField && (
                                   <CButton className="btn-edit" onClick={() => setActiveStep(3)}>
                                        Edit
                                   </CButton>
                              )}
                         </div>
                    )}
               </CCardHeader>
               <CCardBody className={`${activeStep !== 3 ? 'd-none' : ''}`}>
                    <FormCrawlRuleTable initialStepsData={rule} actionType={actionType} />
               </CCardBody>
          </CCard>
     );
};

Step3.propTypes = {
     actionType: PropTypes.string,
};
export default Step3;
